import { useState, useEffect} from "react";

export default function ErrorPopup({ message, show, onDone, duration = 2000 }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (show) {
      setVisible(true);
      const timer = setTimeout(() => {
        setVisible(false);
        // wait for fade-out transition to finish before clearing message upstream
        setTimeout(() => onDone && onDone(), 300);
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [show, duration, onDone]);

  if (!show) return null;

   return (
    <div className={`errorPopup ${visible ? 'errorPopupVisible' : ''}`}>
      {message}
    </div>
  );
}